module.exports = __webpack_public_path__ + "img/thumbnail_BairdsTapir_m_albino.b5eb9d9b.png";